import { Button, Tooltip } from '@mantine/core';
import { IconCode } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { isCodeEditorViewAtom } from '~/atoms/atoms';

export default function CodeViewSwitcher({ color }: { color: 'light' | 'dark' }) {
  const [isCodeEditorView, setIsCodeEditorView] = useAtom(isCodeEditorViewAtom);

  return (
    <Tooltip
      label="Code view"
      position="bottom"
    >
      <Button
        variant="outline"
        size="compact-sm"
        color={color === 'dark' ? 'gray' : 'gray'}
        onClick={() => {
          setIsCodeEditorView(!isCodeEditorView);
        }}
        className={
          isCodeEditorView ?
            `${color === 'dark' ? 'border-blue-700 bg-blue-900/20 text-blue-300' : 'border-blue-300 bg-blue-100 text-blue-700'} `
          : ''
        }
      >
        <IconCode size={16} />
      </Button>
    </Tooltip>
  );
}
